(() => {

    class DeviceBookingCalendar {

        constructor(container) {

            this.container = container;

            this.monthSelect =
                container.querySelector(
                    "[data-calendar-month]"
                );

            this.yearSelect =
                container.querySelector(
                    "[data-calendar-year]"
                );

            this.daysContainer =
                container.querySelector(
                    "[data-calendar-days]"
                );

            this.selectedDateInput =
                document.getElementById(
                    "device-collection-date"
                );

            this.today = new Date();

            this.currentMonth =
                this.today.getMonth();

            this.currentYear =
                this.today.getFullYear();

            /*
            |--------------------------------------------------------------------------
            | First Available Date (3 Working Days)
            |--------------------------------------------------------------------------
            */

            this.selectedDate =
                this.getMinSelectableDate();

            this.minSelectableDate =
                new Date(this.selectedDate);

            this.currentMonth =
                this.selectedDate.getMonth();

            this.currentYear =
                this.selectedDate.getFullYear();

            this.init();

        }

        /*
        |--------------------------------------------------------------------------
        | 3 Working Days
        |--------------------------------------------------------------------------
        */

        getMinSelectableDate() {

            const date =
                new Date(this.today);

            date.setHours(
                0,
                0,
                0,
                0
            );

            let businessDays = 0;

            while (businessDays < 3) {

                date.setDate(
                    date.getDate() + 1
                );

                const day =
                    date.getDay();

                if (

                    day !== 0 &&
                    day !== 6

                ) {

                    businessDays++;

                }

            }

            return date;

        }

        init() {

            this.populateSelectors();

            this.bindEvents();

            this.renderCalendar();

            this.updateHeading();

            this.updateHiddenField();

        }

        populateSelectors() {

            this.monthSelect.value =
                this.currentMonth;

            this.yearSelect.value =
                this.currentYear;

        }

        bindEvents() {

            this.monthSelect.addEventListener(

                "change",

                () => {

                    this.currentMonth =
                        Number(
                            this.monthSelect.value
                        );

                    this.renderCalendar();

                }

            );

            this.yearSelect.addEventListener(

                "change",

                () => {

                    this.currentYear =
                        Number(
                            this.yearSelect.value
                        );

                    this.renderCalendar();

                }

            );

        }

        renderCalendar() {

            this.daysContainer.innerHTML = "";

            const firstDay =
                new Date(
                    this.currentYear,
                    this.currentMonth,
                    1
                );

            const lastDay =
                new Date(
                    this.currentYear,
                    this.currentMonth + 1,
                    0
                );

            const totalDays =
                lastDay.getDate();

            let startDay =
                firstDay.getDay();

            startDay =
                startDay === 0
                    ? 6
                    : startDay - 1;

            /*
            |--------------------------------------------------------------------------
            | Empty Cells
            |--------------------------------------------------------------------------
            */

            for (let i = 0; i < startDay; i++) {

                const empty =
                    document.createElement(
                        "div"
                    );

                empty.className =
                    "booking-calendar__day booking-calendar__day--empty";

                this.daysContainer.appendChild(
                    empty
                );

            }

            /*
            |--------------------------------------------------------------------------
            | Days
            |--------------------------------------------------------------------------
            */

            for (

                let day = 1;
                day <= totalDays;
                day++

            ) {

                const button =
                    document.createElement(
                        "button"
                    );

                button.type = "button";

                button.className =
                    "booking-calendar__day";

                button.textContent = day;

                const date =
                    new Date(
                        this.currentYear,
                        this.currentMonth,
                        day
                    );

                date.setHours(
                    0,
                    0,
                    0,
                    0
                );

                if (

                    date.toDateString() ===
                    this.today.toDateString()

                ) {

                    button.classList.add(
                        "booking-calendar__day--today"
                    );

                }

                if (

                    this.selectedDate &&
                    date.toDateString() ===
                    this.selectedDate.toDateString()

                ) {

                    button.classList.add(
                        "booking-calendar__day--selected"
                    );

                }

                const isWeekend =

                    date.getDay() === 0 ||
                    date.getDay() === 6;

                const isBeforeMinimum =

                    date < this.minSelectableDate;

                if (

                    isWeekend ||
                    isBeforeMinimum

                ) {

                    button.disabled = true;

                    button.classList.add(
                        "booking-calendar__day--disabled"
                    );

                }

                else {

                    button.addEventListener(

                        "click",

                        () => {

                            this.selectedDate =
                                date;

                            this.updateHeading();

                            this.updateHiddenField();

                            this.renderCalendar();

                        }

                    );

                }

                this.daysContainer.appendChild(
                    button
                );

            }

        }

        /*
        |--------------------------------------------------------------------------
        | Heading
        |--------------------------------------------------------------------------
        */

        updateHeading() {

            const heading =
                document.getElementById(
                    "device-selected-date"
                );

            if (!heading) return;

            heading.textContent =
                this.selectedDate.toLocaleDateString(

                    "en-SG",

                    {

                        day: "numeric",
                        month: "long",
                        year: "numeric"

                    }

                );

        }

        /*
        |--------------------------------------------------------------------------
        | Hidden Input + Summary
        |--------------------------------------------------------------------------
        */

        updateHiddenField() {

            if (!this.selectedDateInput)
                return;

            const formatted =
                this.selectedDate.toLocaleDateString(

                    "en-SG",

                    {

                        day: "numeric",
                        month: "long",
                        year: "numeric"

                    }

                );

            this.selectedDateInput.value =
                formatted;

            this.selectedDateInput.dispatchEvent(

                new Event(
                    "input",
                    {
                        bubbles: true
                    }
                )

            );

        }

    }

    document.addEventListener(

        "DOMContentLoaded",

        () => {

            document

                .querySelectorAll(
                    ".booking-calendar"
                )

                .forEach(calendar => {

                    new DeviceBookingCalendar(
                        calendar
                    );

                });

        }

    );

})();